import { Maximize2, Minimize2 } from 'lucide-react';
import { usePosImmersive } from '../../context/PosImmersiveContext';

/**
 * Entrer / quitter le mode caisse immersif (chrome Admin masqué + fallback CSS).
 */
export default function PosImmersiveToggle({ className = '' }) {
  const { active, toggle, fullscreenNative } = usePosImmersive();

  return (
    <button
      type="button"
      data-testid="pos-immersive-toggle"
      aria-pressed={active}
      title={
        active
          ? 'Quitter le mode caisse plein écran'
          : 'Mode caisse plein écran (tablette)'
      }
      onClick={() => toggle()}
      className={`inline-flex items-center gap-1.5 min-h-[44px] min-w-[44px] justify-center rounded-xl border px-3 text-sm font-semibold transition-colors ${
        active
          ? 'border-emerald-300 bg-emerald-50 text-emerald-900'
          : 'border-slate-300 bg-white text-slate-800 hover:bg-slate-50'
      } ${className}`}
    >
      {active ? (
        <>
          <Minimize2 className="h-5 w-5 shrink-0" aria-hidden />
          <span className="hidden sm:inline">Quitter plein écran</span>
        </>
      ) : (
        <>
          <Maximize2 className="h-5 w-5 shrink-0" aria-hidden />
          <span className="hidden sm:inline">Plein écran caisse</span>
        </>
      )}
      {active && !fullscreenNative && (
        <span className="sr-only"> (mode immersif CSS — Fullscreen API indisponible)</span>
      )}
    </button>
  );
}
